// extracted by mini-css-extract-plugin
module.exports = {"title":"edit_postal_code__title___1Q4Ne _type__vx_text-2___Qizsf","title_cf":"edit_postal_code__title_cf___1F1si","save-button":"edit_postal_code__save-button___et_Fw"};